import { StyleSheet } from 'react-native';
import { ThemeColors } from '../../../common/theme-colors';
import theme from '../../../common/theme';

export const getStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    container: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      rowGap: 60,
      padding: 60,
      backgroundColor: colors.elevation1,
    },
    title: {
      fontSize: 28,
      lineHeight: 44,
      color: colors.text,
      textAlign: 'center',
      fontFamily: theme.fonts.bold,
    },
    list: {
      flexGrow: 0,
      flexShrink: 0,
    },
    listContent: {
      gap: 16,
    },
  });
